package org.solyton.solawi.bid.module.shares.`data`.history

import kotlin.collections.List
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscriptionStatusHistories.all]
 */
@ReadWrite
public val all: Lens<ShareSubscriptionStatusHistories, List<ShareSubscriptionStatusHistory>> by
    lazy {
      Lens(
        get = { whole -> whole.all },
        set = { part -> { whole -> whole.copy(all = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscriptionStatusHistories.all]
 */
@ReadWrite
public
    fun ShareSubscriptionStatusHistories.all(`set`: List<ShareSubscriptionStatusHistory>.() -> List<ShareSubscriptionStatusHistory>):
    ShareSubscriptionStatusHistories = copy(all = set(all))
